const amplifyConfig = {
    aws_project_region: "us-east-1",
    aws_cognito_region: "us-east-1",
    aws_user_pools_id: "us-east-1_nKLjopnTS",
    aws_user_pools_web_client_id: "1tmf4qvp0m94oan3cqq4u37k6q",
    federationTarget: "COGNITO_USER_POOLS",
    authenticationFlowType: 'CUSTOM_AUTH',
  };
  export default amplifyConfig;